// Brand palette for the "קד"מ ודוגמיות" (Sales Promotions) feature.
// Uses the portal's standard MUI blue (matches the app's dominant color
// identity) rather than the feature's own routes.js nav-card color.
export const BRAND = "#1976d2";
export const BRAND_DARK = "#115293";
export const BRAND_LIGHT_BG = "#e3f2fd";
export const BRAND_LIGHTER_BG = "#bbdefb";
export const BRAND_SHADOW = "rgba(25, 118, 210, 0.2)";
